import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RedirectAnchorInterceptorService {
  intercept(request: HttpRequest<any>, next: HttpHandler, anchorType: string, anchorValues: string[] = []): Observable<HttpEvent<any>> {
    anchorValues.forEach(value => (anchorType += '; ' + value));
    return next.handle(request.clone({ setHeaders: { 'Redirect-Anchor': anchorType } }));
  }
}
